import { RootState } from "@/redux/store";

export const ratingsSelector = (state: RootState) => state.rating.items;
export const ratingsPageSelector = (state: RootState) => state.rating.page;
